import * as React from 'react';

import { cn } from '@mint-lib/tw-utils';
import { type VariantProps } from 'class-variance-authority';
import { Slot as SlotPrimitive } from 'radix-ui';

import { buttonVariants } from './variants.jsx';

function Button({
  className,
  variant,
  size,
  color,
  icon,
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? SlotPrimitive.Slot : 'button';

  return (
    <Comp
      data-slot="button"
      className={cn(buttonVariants({ variant, size, color, icon, className }))}
      {...props}
    />
  );
}

export { Button };
